import { render, staticRenderFns } from "./ModalSalvar.vue?vue&type=template&id=8d8c8c20&"
import script from "./ModalSalvar.vue?vue&type=script&lang=js&"
export * from "./ModalSalvar.vue?vue&type=script&lang=js&"
import style0 from "./ModalSalvar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports